import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StudyComments } from '@models/studyComments.model';
import { GraphService } from '@services/graph.service';
import { UserService } from '@services/user.service';
import { LoggingService } from '@services/logging.service';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class StudyCommentService {
  savedComments: StudyComments[] = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private logger: LoggingService,
    private graph: GraphService,
    private userService: UserService
  ) {}

  public async SaveComment(studyComment: StudyComments): Promise<StudyComments[]> {
    this.logger.info(this.constructor.name, 'SaveComment', 'Start', studyComment);

    studyComment.isActive = true;

    let savedComment: StudyComments[] = [];
    savedComment = <StudyComments[]>await firstValueFrom(this.http.post<StudyComments[]>('/api/study/SaveComments', studyComment)).catch((e) => {
      this.logger.httpError(this.constructor.name, 'SaveComment', e);
      if (e.status === 401) {
        this.router.navigate(['nostudyaccess']);
      }
    });

    return savedComment;
  }

  public async SaveInternalNotes(internalNotes: StudyComments) {
    this.logger.info(this.constructor.name, 'SaveInternalNotes', 'Start', internalNotes);

    internalNotes.isActive = true;
    await firstValueFrom(this.http.post<StudyComments[]>('/api/study/SaveInternalNotes', internalNotes)).catch((e) => {
      this.logger.httpError(this.constructor.name, 'SaveInternalNotes', e);
      if (e.status === 401) {
        this.router.navigate(['nostudyaccess']);
      }
    });
  }

  public async GetComments(sectionType: number, referenceId: number, comparableId: number): Promise<StudyComments[]> {
    this.logger.info(this.constructor.name, 'GetComments', 'Start');
    let comments: StudyComments[];

    if (referenceId !== undefined && sectionType !== undefined) {
      let param = `/api/study/GetComment/${referenceId}/${sectionType}`;

      if (comparableId !== undefined) {
        param = param + `/${comparableId}`;
      }

      comments = <StudyComments[]>await firstValueFrom(this.http.get<StudyComments[]>(param)).catch((e) => {
        this.logger.httpError(this.constructor.name, 'GetComments', e);
        if (e.status === 401) {
          this.router.navigate(['nostudyaccess']);
        }
      });
    }
    return comments;
  }
}
